<template>
  <div class="container-fluid grayed" style=" min-height: 500px;margin-top: -15px;">
    <div class="container-fixed" style="padding-top: 36px;">
      <section>
        <div class="row aligncontent offset-top-1 offset-bottom-1">
          <VCard v-for="card in cards" :key="card" class="navigation-card col-xl-3 col-l-4 col-m-6 col-s-12" :name="card" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VCard from '@/components/UI/NavigationCards/Card';
import { getVisibleNavigationItems } from '@/utils/navigation';

export default {
  name: 'UiNavigationcardsFlat',

  components: {
    VCard,
  },

  data() {
    const cards = getVisibleNavigationItems(this.$store).map(n => n.name);
    return {
      cards,
    };
  },

  computed: {
    ...mapState('system', ['initComplete']),
  },
};
</script>
